"use client";

import { type ReactNode, type MouseEvent } from "react";
import { Link } from "@/i18n/navigation";
import { useNavigation } from "@/contexts/navigation-context";

interface NavLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  showOverlay?: boolean;
  "data-testid"?: string;
  "aria-label"?: string;
}

export function NavLink({ 
  href, 
  children, 
  className, 
  onClick,
  showOverlay = true,
  ...props 
}: NavLinkProps) {
  const { navigateTo } = useNavigation();

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      onClick();
    }
    
    if (showOverlay) {
      e.preventDefault();
      navigateTo(href);
    }
  };

  return (
    <Link href={href} className={className} onClick={handleClick} {...props}>
      {children}
    </Link>
  );
}
